import cn from 'classnames';

/* Class assignment */
export const patienteditformClass = (className) => cn(className);
